// Take-two chip primitive (UI-SPEC §5.1 / styles.css:178-187).
//
// Wraps the `.chip` recipe from pieces.css: a borderless tint pill in the
// display voice. Variants from the take-two prototype:
//   you · them · gold · leaf
//
// The component is decorative by default (no role). When `ariaLabel` is
// supplied, the chip surfaces as role="status" so a screen reader can
// announce the value (used in the match top bar for live coin/elo state).

import type { CSSProperties, JSX, ReactNode } from 'react'

export type ChipVariant = 'you' | 'them' | 'gold' | 'leaf'

const VARIANT_CLASS: Record<ChipVariant, string> = {
  you: 'chip-you',
  them: 'chip-them',
  gold: 'chip-gold',
  leaf: 'chip-leaf',
}

export interface ChipProps {
  readonly children: ReactNode
  readonly variant?: ChipVariant
  readonly style?: CSSProperties
  readonly ariaLabel?: string
}

export function Chip({
  children,
  variant,
  style,
  ariaLabel,
}: ChipProps): JSX.Element {
  const classes = ['chip', variant ? VARIANT_CLASS[variant] : null]
    .filter(Boolean)
    .join(' ')
  return (
    <span
      className={classes}
      style={style}
      {...(ariaLabel ? { 'aria-label': ariaLabel, role: 'status' } : {})}
    >
      {children}
    </span>
  )
}
